module.exports = __webpack_public_path__ + "img/creditPicture10.24fe4aad.png";